<main class="container-xxl">
  @if (showHeader) {
  <header class="row mt-2 mb-2">
    <div class="col">
      <img src="../assets/images/logo-unidas-min.png" width="120" height="41" alt="Unidas" />
    </div>
    <div class="col div-btn-logout">
      <em class="me-2">{{ userName }}</em>
      @if (showLogout) {
        <a [routerLink]="['/logout']">Sair</a>
      }
    </div>
  </header>
  }

  @if (showLogout && showHeader) {
    <nav class="bar">
      <ul class="menu">
        @if (userPermissions[Permissions.TaxaComunicacao]) {
        <li class="menu__item">
            <a
              id="btn-nav-painel"
              [routerLink]="['/painel']"
              routerLinkActive="menu__item--active"
              >
              Painel
            </a>
        </li>
        }
        @if (userProfileId !== Profile.PRICING && userPermissions[Permissions.MapaGeral]) {
          <li
            class="menu__item dropdown"
            ngbDropdown
            >
            <a id="btn-nav-mapa" role="button" ngbDropdownToggle>Mapa</a>
            <div ngbDropdownMenu aria-labelledby="btn-nav-mapa" class="dropdown-menu">
              <button ngbDropdownItem (click)="openGlobalMapGoogleMaps()">Mapa Google</button>
              <button ngbDropdownItem (click)="openGlobalMap()">Mapa Genérico</button>
              <button ngbDropdownItem (click)="openDesmobilizacao()">Desmobilização</button>
            </div>
          </li>
        }
        @if (userPermissions[Permissions.Alertas]) {
        <li class="menu__item">
            <a
              id="btn-nav-alertas"
              [routerLink]="['/alertas']"
              routerLinkActive="menu__item--active"
              >
              Alertas
            </a>
        </li>
        }
        @if (userPermissions[Permissions.Monitoramento]) {
        <li class="menu__item">
            <a
              id="btn-nav-monitoramento"
              [routerLink]="['/fila-de-monitoramento']"
              routerLinkActive="menu__item--active"
              >
              Monitoramento
            </a>
        </li>
        }
        @if (userProfileId !== Profile.PRICING && userPermissions[Permissions.VeiculosAvulsos]) {
          <li class="menu__item">
            <a
              id="btn-nav-veiculos-avulsos"
              [routerLink]="['/veiculos-avulsos']"
              routerLinkActive="menu__item--active">
              Veículos Avulsos
            </a>
          </li>
        }
        @if (userPermissions[Permissions.HistoricoPosicaoVeiculos]) {
        <li class="menu__item">
            <a
              id="btn-nav-historico-de-posicao"
              [routerLink]="['/historico-posicao']"
              routerLinkActive="menu__item--active"
              >
              Histórico de Posição
            </a>
        </li>
        }
        @if (userPermissions[Permissions.DispositivoManutencao]) {
        <li class="menu__item">
            <a
              id="btn-nav-manutencao"
              [routerLink]="['/manutencao']"
              routerLinkActive="menu__item--active"
              >
              Manutenção
            </a>
        </li>
        }
        @if (userPermissions[Permissions.LogEventos] && userPermissions[Permissions.QuilometragensVeiculos]) {
        <li class="menu__item dropdown" ngbDropdown>
          <a
            ngbDropdownToggle
            id="btn-nav-menu-logs"
            role="button"
            [ngClass]="{ 'menu__item--active': router.url.indexOf('/logs') >= 0 }">
            Logs
          </a>
          <div ngbDropdownMenu aria-labelledby="btn-nav-menu-logs" class="dropdown-menu">
            <a ngbDropdownItem [routerLink]="['/logs/quilometragem']" id="btn-nav-logs-km">
              Alteração de Quilometragem
            </a>
            <a ngbDropdownItem [routerLink]="['/logs/eventos']" id="btn-nav-logs-eventos">
              Eventos
            </a>
          </div>
        </li>
        }
        @if ( !profileNotAllowed ) {
          <li class="menu__item dropdown" ngbDropdown #menu="ngbDropdown" [autoClose]="'outside'">
            <a
              ngbDropdownAnchor
              id="btn-nav-menu-configuracoes"
              role="button"
              [ngClass]="{ 'menu__item--active': router.url.indexOf('/configuracoes') >= 0 }"
              (click)="menu.toggle()">
              Configurações
            </a>
            <div ngbDropdownMenu aria-labelledby="btn-nav-menu-configuracoes" class="dropdown-menu">
              <a ngbDropdownItem [routerLink]="['/configuracoes/areas-de-monitoramento']" id="btn-nav-config-areas-monitoramento" (click)="menu.close()">
                Áreas de Monitoramento 
              </a>
              @if (userIsDeveloper) {
                <a ngbDropdownItem [routerLink]="['/configuracoes/usuarios']" id="btn-nav-config-usuarios" (click)="menu.close()">Usuários</a>
              }
              @if (userPermissions[Permissions.ConfiguracoesJob] || userIsDeveloper || userProfileId === Profile.ADMINISTRATOR ) {
                <div ngbDropdown #submenu="ngbDropdown" placement="right-top">
                  <a class="cursor" ngbDropdownItem ngbDropdownAnchor (click)="submenu.toggle()">
                    Config. do Sistema
                  </a>
                  <div ngbDropdownMenu aria-labelledby="dropdownManual">
                    @if (userPermissions[Permissions.ConfiguracoesJob]) {
                    <a ngbDropdownItem [routerLink]="['/configuracoes/settings-job']" id="btn-nav-settings-job" (click)="menu.close()">Job</a>
                    }
                    @if (userIsDeveloper || userProfileId === Profile.ADMINISTRATOR) {
                    <a ngbDropdownItem [routerLink]="['/configuracoes/parametros-do-sistema']" id="btn-nav-settings-parameters" (click)="menu.close()">Parâmetros</a>
                    <a ngbDropdownItem [routerLink]="['/configuracoes/tipos-de-alerta']" id="btn-nav-settings-alert-types" (click)="menu.close()">Tipos de Alerta</a>
                    <a ngbDropdownItem [routerLink]="['/configuracoes/lojas']" id="btn-nav-settings-alert-types" (click)="menu.close()">Lojas RAC</a>
                    <a ngbDropdownItem [routerLink]="['/configuracoes/pdi']" id="btn-nav-settings-pdi" (click)="menu.close()">PDIs</a>
                    <a ngbDropdownItem [routerLink]="['/configuracoes/oficinas']" id="btn-nav-settings-pdi" (click)="menu.close()">Oficinas</a>
                    <a ngbDropdownItem [routerLink]="['/configuracoes/oficinas-desmobilizacao']" id="btn-nav-settings-garages-desmobi" (click)="menu.close()">Oficina Desmobilização</a>
                    }
                  </div>
                </div>
              }
            </div>
          </li>
        }
      </ul>
      <select class="form-select form-select-sm menu-partner" aria-label="selecionar parceiro" [(ngModel)]="partnerId" (change)="changePartner()">
        <option selected value="">Todos Parceiros</option>
        @for (item of partners; track item) {
          <option [value]="item.id">{{ item.nome }}</option>
        }
      </select>
    </nav>
  }
  <router-outlet></router-outlet>
</main>

<app-loading></app-loading>
<app-toast></app-toast>

<!--
Aplicado loading independente pq a aplicacao nao carrega os componentes
filhos ate carregar os perfis
-->
@if (loadingprofiles) {
  <div class="loading">
    <div class="spinner-grow text-primary"></div>
  </div>
}
